import SimpleDialog from 'app/componentV4/Dialog/SimpleDialog'
import React from 'react'
import { FormattedMessage } from 'react-intl'
import { usePlace } from 'commons/usePlace'
import { useGroupDialog } from '../contexts/GroupDialogContext'
import CreateGroupForm from 'app/componentV4/CreateGroupForm/CreateGroupForm'
import { DIALOG_KEYS } from '../constants'

const AddGroup = () => {
  const place = usePlace()
  const { dialogState, closeDialog, setLoading } = useGroupDialog()
  const { open, action, isLoading } = dialogState[DIALOG_KEYS.GROUP_ADD]

  const handleSubmit = (
    values,
    { resetForm, setFieldError, setSubmitting },
  ) => {
    setLoading(DIALOG_KEYS.GROUP_ADD, true)

    const data = {
      name: values.groupName?.trim(),
      placeId: place.id,
      tags: values.subGroups
        .map((item) => ({ name: item.title }))
        .filter((item) => item.name !== ''),
    }
    action?.onSubmit?.({
      data,
      resetData: resetForm,
      setFieldError,
    })
    setSubmitting(false)
  }

  const handleCancel = () => {
    closeDialog(DIALOG_KEYS.GROUP_ADD)
  }

  return (
    <SimpleDialog
      id="dialog-add-group"
      open={open}
      title={
        <div
          style={{ maxWidth: '500px' }}
          className="text-blue-950 py-5 px-10 text-16 font-medium"
        >
          <FormattedMessage id="groupsv4.add.dialog.title" />
        </div>
      }
      isLoading={isLoading}
      onClose={() => closeDialog(DIALOG_KEYS.GROUP_ADD)}
    >
      <div className="py-5 px-10">
        <CreateGroupForm
          onSubmit={handleSubmit}
          onCancel={handleCancel}
          disabled={isLoading}
        />
      </div>
    </SimpleDialog>
  )
}

export default AddGroup
